<template>
  <div id="autocomplete">
    <div id="label" v-if="label">
      <label class="title" for="auto-input">{{label}}</label>
    </div>
    <div id="auto-input" class="my-1">
      <b-input-group @mouseover="hover(true)" @mouseout="hover(false)" class="my-1">
        <auto-input class="auto-input"
                    id="typeahead"
                    ref="typeahead"
                    size="sm"
                    v-model="keyword"
                    :data="data"
                    @input="input"
                    @hit="hit"
                    :maxMatches="max"
                    :minMatchingChars="min"
                    :serializer="data => data.text"
                    :class="{active : isActive, hover: isHover}"
                    :placeholder="placeholder"
        ></auto-input>
        <b-input-group-append>
          <b-button class="input-icon" variant="primary" size="sm" :class="{active : isActive, hover: isHover}"
                    @click="search">
            <i class="search"><img src="./icon_search.png" height="12" width="12"/></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>

<script>
/*
  ※주의 : 데이터 추가할때 주석부분에도 추가해주세요.※
  =================================================
  ※ prop data ※
  [label : String]
  [max] : String] => default : 1000 , 최대 max 만큼 autocomplete 함
  [min] : String] => default : 1 , 최소 입력값 min 만큼 autocomplete 함
  [data : Array] => data key 값에 무조건 text(화면에 보여지는 값)이 있어야함.
  =================================================
  ※ Event ※
  search => 버튼 클릭시 이벤트 발생.
  input => 텍스트 입력시 이벤트 발생.
  =================================================
*/
import AutoInput from 'vue-bootstrap-typeahead'

export default {
  props: {
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 1000
    },
    min: {
      type: Number,
      default: 1
    },
    data: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    AutoInput
  },
  data () {
    return {
      keyword: null,
      isActive: false,
      isHover: false
    }
  },
  mounted () {
    const el = document.getElementById('typeahead')
    el.addEventListener('blur', this.blur)
  },
  beforeDestroy () {
    try {
      const el = document.getElementById('typeahead')
      el.removeEventListener('blur', this.blur)
    } catch (e) {
      // console.log(e)
    }

  },
  methods: {
    blur (value) {
      if (value.target.value != null && value.target.value != '') this.isActive = false, this.isHover = false
    },
    hit (value) {
      if (value.text != null && value.text != '') this.isActive = false, this.isHover = false
    },
    hover (isHover) {
      if (isHover) this.isHover = isHover
      else this.isHover = isHover
    },
    input (value) {
      if (value != null && value != '') this.isActive = true, this.isHover = false
      else this.isActive = false

      this.$emit('input', value)
    },
    search () {
      this.$emit('search', this.keyword)
    }
  },
}
</script>

<style scoped>
#autocomplete {
  float: left;
  height: 99%;
  width: 100%;
}

.title {
  color: #000000;
}

#auto-input .auto-input {
  width: 78%;
}

#auto-input .input-icon {
  position: absolute;
  color: #FFFFFF;
  background-color: #fff;
  border-color: #DDDDDD;
  border-radius: 0px 4px 4px 0px;
  border-left: 0px;
  width: 22%;
}

#auto-input .input-icon.hover {
  color: #FFFFFF;
  background-color: #18A0FB;
  border-color: #18A0FB;
  border-radius: 0px 4px 4px 0px;
  border-left: 0px;
}

#auto-input .input-icon .search {
  margin-left: -4px;
}

#auto-input .auto-input >>> .form-control {
  background: #FFFFFF;
  border-left: 1px solid #E5E5E5;
  border-top: 1px solid #E5E5E5;
  border-bottom: 1px solid #E5E5E5;
  border-right: 0px;
  box-sizing: border-box;
  padding-top: 3px;
  padding-bottom: 2px;

  font-size: 12px;
  height: 31px;
}

#auto-input .auto-input.hover >>> .form-control {
  border-left: 1px solid #18A0FB !important;
  border-top: 1px solid #18A0FB !important;
  border-bottom: 1px solid #18A0FB !important;
  border-right: 0px !important;
  color: #18A0FB;
  cursor: pointer;
}

#auto-input .auto-input.active >>> .form-control {
  border: 1px solid #18A0FB !important;
  color: #18A0FB;
}

#auto-input .input-icon.active {
  border: 1px solid #18A0FB !important;
  color: #FFFFFF;
  background-color: #18A0FB;
}

#auto-input .auto-input >>> .form-control:focus {
  box-shadow: none;
  border-left: 1px solid #ced4da !important;
  border-top: 1px solid #ced4da !important;
  border-bottom: 1px solid #ced4da !important;
  border-right: 0px !important;
}

#auto-input .auto-input >>> .list-group.shadow {
  padding-top: 0;
}

#auto-input .input-icon .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
}

#auto-input .input-icon:focus {
  box-shadow: none;
}

#auto-input .input-icon {
  z-index: 0;
}

/* 리스트 css */
#auto-input .auto-input >>> .vbt-autcomplete-list {
  max-height: 200px;
  background: #FFFFFF;
  font-size: 12px;
}

#auto-input .auto-input >>> .vbt-autcomplete-list .vbst-item {
  border: none !important;
}

#auto-input .auto-input.active >>> .vbt-autcomplete-list .vbst-item {
  border: 1px solid #18A0FB;
  box-sizing: border-box;
  border-radius: 4px 0px 4px 4px;
}

#auto-input .auto-input >>> .vbt-autcomplete-list .vbst-item:hover {
  background: #F5F6FA;
  color: #18A0FB;
}

/* 스크롤 바 */
#auto-input .auto-input >>> .vbt-autcomplete-list::-webkit-scrollbar {
  width: 10px;
}

#auto-input .auto-input >>> .vbt-autcomplete-list::-webkit-scrollbar-thumb {
  background-color: #DDDDDD;;
  border-radius: 50px;
  background-clip: padding-box;
  border: 2px solid transparent;
}
</style>
